import { LoadingButton } from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React from 'react';

import ProductReportListItem from './ProductReportListItem';

const ProductReportsDialog = ({
  open,
  onClose,
  loading,
  canMutateReports,
  step,
  reports,
  form,
  onFormChange,
  editing,
  onStartCreate,
  onStartEdit,
  onBackToList,
  onSave,
  onDelete,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth="sm"
    sx={{ direction: 'rtl' }}
  >
    <DialogTitle>
      {step === 'form'
        ? editing
          ? 'ویرایش گزارش'
          : 'گزارش جدید'
        : 'گزارشات محصول'}
    </DialogTitle>
    <DialogContent>
      {step === 'list' ? (
        <Stack gap={1.5} pt={1}>
          {reports.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              گزارشی ثبت نشده است
            </Typography>
          ) : null}

          {reports.map(report => (
            <ProductReportListItem
              key={report.guid}
              report={report}
              canMutate={canMutateReports}
              onEdit={onStartEdit}
              onDelete={onDelete}
            />
          ))}
        </Stack>
      ) : null}

      {step === 'form' && canMutateReports ? (
        <Stack gap={1} pt={1}>
          <TextField
            label="عنوان"
            variant="standard"
            value={form.title}
            onChange={e => onFormChange({ title: e.target.value })}
          />
          <TextField
            label="توضیحات"
            variant="standard"
            multiline
            minRows={2}
            value={form.description}
            onChange={e => onFormChange({ description: e.target.value })}
          />
          <TextField
            label="تعداد"
            variant="standard"
            type="number"
            value={form.quantity}
            onChange={e => onFormChange({ quantity: e.target.value })}
          />
        </Stack>
      ) : null}
    </DialogContent>
    <DialogActions sx={{ gap: 1, p: 2 }}>
      {step === 'list' ? (
        <>
          <Button onClick={onClose}>بستن</Button>
          {canMutateReports ? (
            <Button variant="contained" onClick={onStartCreate}>
              گزارش جدید
            </Button>
          ) : null}
        </>
      ) : (
        <>
          <Button onClick={onBackToList}>بازگشت</Button>
          <LoadingButton loading={loading} variant="contained" onClick={onSave}>
            ثبت گزارش
          </LoadingButton>
        </>
      )}
    </DialogActions>
  </Dialog>
);

export default ProductReportsDialog;
